module.exports = __webpack_public_path__ + "img/8578af0.jpg";